import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from '../../../api/query-keys';
import { useAuth } from '../../../auth/AuthProvider';
import { permissions } from '../../../auth/permissions';
import { createCheckoutSession, createPortalSession, getBilling } from './billing.api';

export function useBilling() {
  const auth = useAuth();
  return useQuery({
    queryKey: queryKeys.billing(auth.activeCustomerId),
    queryFn: () => getBilling(auth.activeCustomerId!),
    enabled: Boolean(auth.activeCustomerId && auth.can(permissions.billingRead)),
    refetchInterval: (query) => query.state.data?.status === 'PENDING' ? 3000 : false,
  });
}

export function useStartCheckout() {
  const auth = useAuth();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => createCheckoutSession(auth.activeCustomerId!),
    onSuccess: async (result) => {
      queryClient.setQueryData(queryKeys.billing(auth.activeCustomerId), result.billing);
    },
  });
}

export function useOpenBillingPortal() {
  const auth = useAuth();
  return useMutation({
    mutationFn: () => createPortalSession(auth.activeCustomerId!),
  });
}
